import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'gas-icon-definitions',
  templateUrl: './gas-icon-definitions.component.html',
  styleUrls: ['./gas-icon-definitions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GasIconDefinitionsComponent {
  @Input() public width: number;
  @Input() public height: number;
}
